/**
 * Construct an array based on the start, stop, and step value.
 *
 * @param {number} start - The min value in the array
 * @param {number} stop - The max value in the array
 * @param {number} step - The gap between two adjacent values
 * @returns {array}
 */
export const getArrayFromRange = (start: number, stop: number, step: number): Array<number> =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
